import { render, staticRenderFns } from "./addGuangGao.vue?vue&type=template&id=775217e3&scoped=true&"
import script from "./addGuangGao.vue?vue&type=script&lang=js&"
export * from "./addGuangGao.vue?vue&type=script&lang=js&"
import style0 from "./addGuangGao.vue?vue&type=style&index=0&id=775217e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775217e3",
  null
  
)

export default component.exports